import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React__default, { forwardRef, useMemo } from 'react';
import { CardSection } from './CardSection.js';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import { matchesDisplayName } from '../../utils/displayName.js';
import { jsx } from '@emotion/react';

const CARD_DEFAULT_TAG = "div";
const selectedStyles = {
  boxShadow: "medium",
  outlineWidth: "0.125rem",
  outlineOffset: "-0.125rem"
};
const StyledCard = /*#__PURE__*/themed(CARD_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: ["selected"],
  shouldForwardProp: prop => prop !== "selected",
  target: "esu7hk30"
} : {
  styleProps: ["selected"],
  shouldForwardProp: prop => prop !== "selected",
  target: "esu7hk30",
  label: "StyledCard"
})(_ref => {
  let {
    selected
  } = _ref;
  return [{
    bg: "background",
    border: "1px solid",
    borderColor: "border.weak",
    borderRadius: "lg",
    display: "block",
    overflow: "hidden",
    whiteSpace: "normal",
    outlineStyle: "solid",
    outlineColor: "border.primary",
    outlineWidth: "0",
    outlineOffset: "0"
  }, selected !== undefined && {
    cursor: "pointer",
    boxShadow: "none",
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "border-color", "background-color", "box-shadow");
    },
    ":focus-visible": {
      boxShadow: "focus"
    },
    "&:hover": {
      boxShadow: "low"
    },
    "&:active": {
      boxShadow: "inset"
    }
  }, selected === true && {
    ...selectedStyles
  }];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTZCbUIiLCJmaWxlIjoiQ2FyZC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVhY3RFbGVtZW50LCB1c2VNZW1vIH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgeyBJbmRlZWRUaGVtZSB9IGZyb20gXCJAaW5kZWVkL2lmbC10aGVtZXNcIjtcbmltcG9ydCB7IENhcmRTZWN0aW9uIH0gZnJvbSBcIi4vQ2FyZFNlY3Rpb25cIjtcbmltcG9ydCB7IHRoZW1lZCwgU3R5bGVQcm9wcyB9IGZyb20gXCJAaW5kZWVkL2lmbC1jc3NcIjtcbmltcG9ydCB0cmFuc2l0aW9uIGZyb20gXCIuLi8uLi91dGlscy90cmFuc2l0aW9uXCI7XG5pbXBvcnQgeyBtYXRjaGVzRGlzcGxheU5hbWUgfSBmcm9tIFwiLi4vLi4vdXRpbHMvZGlzcGxheU5hbWVcIjtcblxuaW1wb3J0ICogYXMgUG9seW1vcnBoaWMgZnJvbSBcIi4uLy4uL3R5cGVzL3BvbHltb3JwaGljXCI7XG5cbmV4cG9ydCBjb25zdCBDQVJEX0RFRkFVTFRfVEFHID0gXCJkaXZcIjtcblxuZXhwb3J0IGludGVyZmFjZSBDYXJkUHJvcHMgZXh0ZW5kcyBTdHlsZVByb3BzIHtcbiAgLyoqXG4gICAqIFVzZSBpbiBhIGNvbnRyb2xsZWQgZmFzaGlvbiB0byBhcHBseSBpbnRlcmFjdGl2ZSBzZWxlY3RhYmxlIHN0eWxlcy5cbiAgICovXG4gIHNlbGVjdGVkPzogYm9vbGVhbjtcbn1cblxuZXhwb3J0IHR5cGUgQ2FyZENvbXBvbmVudCA9IFBvbHltb3JwaGljLkZvcndhcmRSZWZDb21wb25lbnQ8XG4gIHR5cGVvZiBDQVJEX0RFRkFVTFRfVEFHLFxuICBDYXJkUHJvcHNcbj47XG5cbmV4cG9ydCBjb25zdCBzZWxlY3RlZFN0eWxlcyA9IHtcbiAgYm94U2hhZG93OiBcIm1lZGl1bVwiLFxuICBvdXRsaW5lV2lkdGg6IFwiMC4xMjVyZW1cIixcbiAgb3V0bGluZU9mZnNldDogXCItMC4xMjVyZW1cIlxufTtcblxuY29uc3QgU3R5bGVkQ2FyZCA9IHRoZW1lZChDQVJEX0RFRkFVTFRfVEFHLCB7XG4gIHN0eWxlUHJvcHM6IFtcInNlbGVjdGVkXCJdLFxuICBzaG91bGRGb3J3YXJkUHJvcDogKHByb3A6IHN0cmluZyk6IGJvb2xlYW4gPT4gcHJvcCAhPT0gXCJzZWxlY3RlZFwiXG59KTxDYXJkUHJvcHM+KCh7IHNlbGVjdGVkIH0pID0+IFtcbiAge1xuICAgIGJnOiBcImJhY2tncm91bmRcIixcbiAgICBib3JkZXI6IFwiMXB4IHNvbGlkXCIsXG4gICAgYm9yZGVyQ29sb3I6IFwiYm9yZGVyLndlYWtcIixcbiAgICBib3JkZXJSYWRpdXM6IFwibGdcIixcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgd2hpdGVTcGFjZTogXCJub3JtYWxcIixcbiAgICBvdXRsaW5lU3R5bGU6IFwic29saWRcIixcbiAgICBvdXRsaW5lQ29sb3I6IFwiYm9yZGVyLnByaW1hcnlcIixcbiAgICBvdXRsaW5lV2lkdGg6IFwiMFwiLFxuICAgIG91dGxpbmVPZmZzZXQ6IFwiMFwiXG4gIH0sXG4gIHNlbGVjdGVkICE9PSB1bmRlZmluZWQgJiYge1xuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICB0cmFuc2l0aW9uOiAoeyB0cmFuc2l0aW9ucyB9OiBJbmRlZWRUaGVtZSkgPT5cbiAgICAgIHRyYW5zaXRpb24oXG4gICAgICAgIHRyYW5zaXRpb25zLmRlZmF1bHQsXG4gICAgICAgIFwiYm9yZGVyLWNvbG9yXCIsXG4gICAgICAgIFwiYmFja2dyb3VuZC1jb2xvclwiLFxuICAgICAgICBcImJveC1zaGFkb3dcIlxuICAgICAgKSxcbiAgICBcIjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJveFNoYWRvdzogXCJmb2N1c1wiXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYm94U2hhZG93OiBcImxvd1wiXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJveFNoYWRvdzogXCJpbnNldFwiXG4gICAgfVxuICB9LFxuICBzZWxlY3RlZCA9PT0gdHJ1ZSAmJiB7XG4gICAgLi4uc2VsZWN0ZWRTdHlsZXNcbiAgfVxuXSk7XG5cbi8qKlxuICogQHNlZSBodHRwczovL2V4cGVyaWVuY2UuaW5kZWVkLmRlc2lnbi9jb21wb25lbnRzL2lkcy9jYXJkXG4gKi9cbmV4cG9ydCBjb25zdCBDYXJkID0gZm9yd2FyZFJlZigoeyBjaGlsZHJlbiwgLi4ucHJvcHMgfSwgcmVmKSA9PiB7XG4gIGNvbnN0IHRhYkluZGV4ID1cbiAgICBwcm9wcy50YWJJbmRleCA/PyAocHJvcHMuc2VsZWN0ZWQgIT09IHVuZGVmaW5lZCA/IDAgOiB1bmRlZmluZWQpO1xuICBjb25zdCB3cmFwQ2hpbGRyZW4gPSB1c2VNZW1vKCgpID0+IHtcbiAgICBpZiAoIWNoaWxkcmVuKSByZXR1cm4gdHJ1ZTtcblxuICAgIC8vIENoZWNrIGlmIGFueSBkaXJlY3QgY2hpbGQgaXMgYSBDYXJkU2VjdGlvblxuICAgIGNvbnN0IGNoaWxkcmVuQXJyYXkgPSBSZWFjdC5DaGlsZHJlbi50b0FycmF5KGNoaWxkcmVuKTtcblxuICAgIHJldHVybiAhY2hpbGRyZW5BcnJheS5zb21lKGNoaWxkID0+XG4gICAgICBtYXRjaGVzRGlzcGxheU5hbWUoW0NhcmRTZWN0aW9uXSwgY2hpbGQgYXMgUmVhY3RFbGVtZW50KVxuICAgICk7XG4gIH0sIFtjaGlsZHJlbl0pO1xuXG4gIHJldHVybiAoXG4gICAgPFN0eWxlZENhcmQgcmVmPXtyZWZ9IHRhYkluZGV4PXt0YWJJbmRleH0gey4uLnByb3BzfT5cbiAgICAgIHt3cmFwQ2hpbGRyZW4gPyA8Q2FyZFNlY3Rpb24+e2NoaWxkcmVufTwvQ2FyZFNlY3Rpb24+IDogY2hpbGRyZW59XG4gICAgPC9TdHlsZWRDYXJkPlxuICApO1xufSkgYXMgQ2FyZENvbXBvbmVudDtcbiJdfQ== */");

/**
 * @see https://experience.indeed.design/components/ids/card
 */
const Card = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    children,
    ...props
  } = _ref3;
  const tabIndex = props.tabIndex ?? (props.selected !== undefined ? 0 : undefined);
  const wrapChildren = useMemo(() => {
    if (!children) return true;

    // Check if any direct child is a CardSection
    const childrenArray = React__default.Children.toArray(children);
    return !childrenArray.some(child => matchesDisplayName([CardSection], child));
  }, [children]);
  return jsx(StyledCard, _extends({
    ref: ref,
    tabIndex: tabIndex
  }, props), wrapChildren ? jsx(CardSection, null, children) : children);
});

export { CARD_DEFAULT_TAG, Card, selectedStyles };
